import React__default from "react";
import clsx from "clsx";
import { getBackgroundColorClass } from "../../colors/index.mjs";
import { CardContext } from "../card/card.mjs";
const CardHeader = (props) => {
  const { padding, background: cardColor } = React__default.useContext(CardContext);
  const { background, children, className } = props;
  const getBackground = () => {
    if (background === "transparent") {
      return;
    } else if (background) {
      return background;
    }
    switch (cardColor) {
      case "neutral-bg-level-1":
        return "neutral-bg-level-2";
      case "transparent":
        return;
      default:
        return "neutral-bg-subtlest";
    }
  };
  const backgroundValue = getBackground();
  const backgroundClass = backgroundValue ? getBackgroundColorClass(backgroundValue) : void 0;
  const classNames = clsx(
    "card__header",
    typeof padding === "string" ? "card__header--padding-".concat(padding) : {
      "card__content--padding-medium": true,
      ["card__header--padding-horizontal-".concat(padding.right)]: padding.right === padding.left,
      ["card__header--padding-left-".concat(padding.left)]: padding.right !== padding.left && padding.left,
      ["card__header--padding-right-".concat(padding.right)]: padding.right !== padding.left && padding.right
    },
    backgroundClass,
    className
  );
  return /* @__PURE__ */ React__default.createElement("div", { className: classNames }, children);
};
export {
  CardHeader
};
